import { Navigate, useLocation } from "react-router-dom";

/** Back-compat: old /discovery-cockpit URLs → /discovery-hub */
const DiscoveryHubLegacyRedirect = () => {
  const location = useLocation();
  const target = location.pathname.replace(
    /\/discovery-cockpit\/?$/,
    "/discovery-hub"
  );
  return <Navigate to={`${target}${location.search}`} replace />;
};

export default DiscoveryHubLegacyRedirect;
